<template>
  <div class="user-group-section">
    <h5>{{ $t('global.field.userGroup') }}</h5>
    <FormulateForm ref="formRef" v-model="localFormValues">
      <FormulateInput
        ref="userGroupInputRef"
        type="value-help-v2"
        name="user_group_id"
        trackBy="id"
        :placeholder="`${$t('global.form.select')} ${$t('global.field.userGroup')}`"
        displayedBy="name"
        :listGetter="userGroupQuery"
        :multiple="false"
        :tableFields="userGroupTableFields"
        :modalTitle="`${$t('global.form.select')} ${$t('global.field.userGroup')}`"
        :help="true"
        :isMandatory="true"
        validation="required"
        validation-behavior="live"
        @update:fullObject="updateUserGroupFullObject"
      />
    </FormulateForm>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import { EventBus } from '../../lib/event-bus.js'

export default {
  computed: {
    ...mapState('fleetTaskInstant', ['formValues']),
    localFormValues: {
      get() {
        return this.formValues
      },
      set(value) {
        this.$store.dispatch('fleetTaskInstant/setFormValues', value)
      },
    },
    userGroupTableFields() {
      return [
        {
          label: this.$t('global.field.userGroup'),
          key: 'name',
          isSortable: false,
        },
        {
          label: this.$t('global.field.vehicleGroup'),
          key: 'vgroups',
          isSortable: false,
          formatter: (value) => {
            return value?.length != null
              ? value.length === 0
                ? this.$t('global.text.allVehicleGroup')
                : value.length
              : '-'
          },
        },
      ]
    },
  },
  watch: {
    'formValues.user_group_id': function (newValue) {
      if (newValue !== null) {
        EventBus.$emit('get-nearest-vehicle')
      }
    },
    '$i18n.locale': function () {
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.hasValidationErrors()
        }
      })
    },
  },
  created() {
    EventBus.$on('open-user-group-modal', this.openModal)
  },
  beforeDestroy() {
    EventBus.$off('open-user-group-modal', this.openModal)
  },
  methods: {
    updateUserGroupFullObject(value) {
      this.$store.dispatch('fleetTaskInstant/setUserGroupFullObject', value)
    },
    openModal() {
      if (this.$refs.userGroupInputRef) {
        const inputWrapper = this.$refs.userGroupInputRef.$el.querySelector(
          '.formulate-input-element'
        )
        if (inputWrapper) {
          inputWrapper.click()
        }
      }
    },
    async userGroupQuery(opts) {
      let result = {}
      try {
        const filter = {
          pagination: {
            page: opts?.page,
            show: opts?.limit,
          },
          search: opts?.search,
        }

        const res = await this.$apollo.query({
          query: GET_USER_GROUP,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              ...filter,
            },
          },
        })

        const ugroups = res.data.ugroups.ugroups

        result = {
          metadata: {
            total_count: ugroups.pagination.total,
            page: ugroups.pagination.page,
          },
          data: {
            paginated_result: ugroups.data,
          },
        }

        return result
      } catch (error) {
        console.error('Failed to fetch user groups:', error)
        return {
          metadata: { total_count: 0, page: 1 },
          data: { paginated_result: [] },
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.user-group-section {
  padding: 0 16px;
}
</style>
